module.exports = __webpack_public_path__ + "static/media/1a.9f84b8e4.jpg";